import { useCallback } from 'react';

import { useToast } from '@vimeo/bokeh';

// Custom hook to use a nice function pattern instead of an object, with provision for a default variant
export const useBokehToast = () => {
  const notify = useToast();
  return useCallback(
    (
      title: string,
      status: 'success' | 'info' | 'warning' | 'neutral' = 'neutral',
      duration?: number,
    ) => {
      notify({
        title,
        variant: status,
        duration,
      });
    },
    [notify],
  );
};
